
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg';

class Text extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div className="input-wrap">
                <input className={this.props.error ? 'required' : null} type={this.props.type} onChange={this.props.onChange} value={this.props.value} placeholder={this.props.placeholder}/>
                {this.props.error && this.props.errorText && <span style={{ fontSize: '12px', marginLeft: '15px', color: '#DA212E' }}>{this.props.errorText}</span>}
            </div>
        );
    }
}

export default Text;
